import SplitButtonAction from "./SplitButtonAction.vue";
import { pluginify } from "./../../util";
export default pluginify(SplitButtonAction);
export { SplitButtonAction };
